<ion-row *ngIf="floorShops.length > 0" class="slider-container">
  <swiper-container [@listStagger]="shops.length" #shopsSlider pager="true" space-between="16" breakpoints="{&quot;0&quot;:{&quot;slidesPerView&quot;:2.5},&quot;768&quot;:{&quot;slidesPerView&quot;:4.5},&quot;1000&quot;:{&quot;slidesPerView&quot;:6.5}}">
    <swiper-slide *ngFor="let shop of floorShops">
      <div class="slide-content" [languageRouter]="['tienda', shop.shopUrl]">
        <img *ngIf="shop.data" class="store-logo" src="{{ shop.data.logo || shop.data.backgroundImage }}"
          alt="{{ shop.data.name }}" />
      </div>
    </swiper-slide>
  </swiper-container>
  <div class="stores-carousel-controls">
    <ion-button fill="clear" (click)="slidePrev()">
      <i class="icon-chevron-left"></i>
    </ion-button>
    <ion-button fill="clear" (click)="slideNext()">
      <i class="icon-chevron-right"></i>
    </ion-button>
  </div>
</ion-row>
